import axios from '@/user/apis/common/axios-handle-error.service'

/**
 * 접수한 시험 조회
 *
 * @method getCertificationAppliedExams
 * @param {object<{ page, size }>} options - page, size
 * @returns {promise} {data} = response or error
 */
function getCertificationAppliedExams({ page, size }) {
  return new Promise((resolve, reject) => {
    const url = `/api/certification/v1/applied-exams`
    const params = `?page=${page}&size=${size}`

    return axios
      .get(`${url}${params}`)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

/**
 * 자격증 시험 결과 조회
 * @method getCertificationExamResults
 * @param {object<{ page, size }>} options - page, size
 * @returns {promise} {data} = response or error
 */
function getCertificationExamResults({ page, size }) {
  return new Promise((resolve, reject) => {
    const params = `?page=${page}&size=${size}`
    const url = `/api/certification/v1/completed-exams`

    return axios
      .get(`${url}${params}`)
      .then(({ data }) => resolve(data))
      .catch(reject)
  })
}

export const ExamServiceApi = {
  getCertificationAppliedExams,
  getCertificationExamResults,
}
